module.exports = __webpack_public_path__ + "static/savantLogo-8b1673241c9f31fa05abd9ddb09bbe60.png";